var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 65.362,
    viewBox: "0 0 37 65.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_125",
    "data-name": "\\u9577\\u65B9\\u5F62 125",
    width: 32.543,
    height: 43.479,
    transform: "translate(0 0)",
    fill: "#1eaedb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_180",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 180",
    transform: "translate(-723 -21.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_162",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 162",
    transform: "translate(725.229 21.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_160",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 160",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_58",
    "data-name": "\\u30D1\\u30B9 58",
    d: "M28.005,31.744c-1.421,1.034-1.985,3.859-3.691,4.413a3.668,3.668,0,0,1-2.466-.39L27.88,47.014l2.2-4.452L35,43.193,28.672,31.387a3.2,3.2,0,0,0-.666.357",
    transform: "translate(-2.461 -3.535)",
    fill: "#1eaedb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_59",
    "data-name": "\\u30D1\\u30B9 59",
    d: "M10.69,36.157C8.984,35.6,8.419,32.778,7,31.744a3.16,3.16,0,0,0-.666-.357L0,43.193l4.925-.631,2.2,4.452,6.032-11.247a3.669,3.669,0,0,1-2.466.39",
    transform: "translate(0 -3.535)",
    fill: "#1eaedb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_60",
    "data-name": "\\u30D1\\u30B9 60",
    d: "M29.707,19.8c.478-1.472,2.727-2.729,2.727-4.361s-2.249-2.888-2.727-4.361c-.5-1.525.568-3.86-.357-5.131s-3.488-.989-4.771-1.922S22.8.579,21.278.083c-1.472-.477-3.359,1.253-4.991,1.253S12.769-.394,11.3.083C9.771.579,9.267,3.1,8,4.03s-3.838.64-4.771,1.922.138,3.605-.357,5.131C2.39,12.555.141,13.812.141,15.444S2.39,18.331,2.868,19.8c.5,1.525-.568,3.86.357,5.131S6.713,25.924,8,26.857s1.775,3.451,3.3,3.946c1.472.478,3.359-1.253,4.991-1.253s3.518,1.731,4.991,1.253c1.526-.5,2.03-3.022,3.3-3.946s3.838-.639,4.771-1.922-.138-3.6.357-5.131m-13.42,6.263A10.624,10.624,0,1,1,26.911,15.444,10.624,10.624,0,0,1,16.288,26.068",
    transform: "translate(-0.016 0)",
    fill: "#1eaedb"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_126",
    "data-name": "\\u9577\\u65B9\\u5F62 126",
    width: 37,
    height: 17,
    rx: 2,
    transform: "translate(723 70.181)",
    fill: "#1eaedb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_62",
    "data-name": "\\u30D1\\u30B9 62",
    d: "M1.58-6.6H8.39v1.39h.77V-7.3H5.36V-8.36H4.59V-7.3H.83v2.09h.75ZM7.69-4.8v-.69H2.3v.69ZM6.95-.09c-.42,0-.49-.06-.49-.34V-2.96H9.4v-.7H.6v.7H3.18A3.146,3.146,0,0,1,.38.15,2.241,2.241,0,0,1,.82.78,3.815,3.815,0,0,0,3.97-2.96H5.72V-.43C5.72.36,5.96.59,6.87.59H8.41C9.2.59,9.42.24,9.5-1.12a3.164,3.164,0,0,1-.68-.29C8.79-.27,8.72-.09,8.35-.09ZM18.58-7.64l-.16.05H11.31v.73h6.44a12.372,12.372,0,0,1-2.33,1.88h-.49V-.21c0,.18-.07.24-.29.25s-1,.01-1.82-.02a2.561,2.561,0,0,1,.3.74A9.361,9.361,0,0,0,15.18.65c.38-.12.52-.35.52-.85V-4.33a14.049,14.049,0,0,0,3.46-2.89Z",
    transform: "translate(731.73 82.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_62_-_\\u30A2\\u30A6\\u30C8\\u30E9\\u30A4\\u30F3",
    "data-name": "\\u30D1\\u30B9 62 - \\u30A2\\u30A6\\u30C8\\u30E9\\u30A4\\u30F3",
    d: "M4.09-8.86H5.86V-7.8h3.8v3.09H8.19v.41H1.8v-.41H.33V-7.8H4.09ZM7.89-6.1H2.08v.11H7.89ZM18.67-8.192l1.217.882-.344.411A14.59,14.59,0,0,1,16.2-4.045V-.2a1.228,1.228,0,0,1-.869,1.327l-.012,0a9.245,9.245,0,0,1-2.2.13h-.434L12.625.831a2.145,2.145,0,0,0-.239-.563L11.94-.513l.9.033c.633.023,1.162.026,1.361.026h.231V-5.48h.849a11.025,11.025,0,0,0,1.2-.88H10.81V-8.09h7.534ZM.1-4.16H9.9v1.7H6.96V-.59H8.266a7.843,7.843,0,0,0,.054-.833l.023-.891.748.484a2.7,2.7,0,0,0,.552.231l.379.114L10-1.091C9.929.1,9.761,1.09,8.41,1.09H6.87A1.833,1.833,0,0,1,5.619.748,1.516,1.516,0,0,1,5.22-.43V-2.46H4.4A4.188,4.188,0,0,1,.954,1.262l-.416.116L.363.983A1.809,1.809,0,0,0,.051.526L-.67-.1.259-.335C1.837-.728,2.369-1.379,2.595-2.46H.1Z",
    transform: "translate(731.73 82.181)",
    fill: "rgba(0,0,0,0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon_done.a2a3d7840de63254c5bd54d47739ab93.svg";
export { ForwardRef as ReactComponent };